import './styles/index.scss';

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { configureStore, history } from './store/configureStore';
import Root from './containers/Root';
import { FETCH } from './middlewares/fetch-middleware';

import { SET_CLADDINGS } from './modules/data/claddings';
import { SET_ENERGY } from './modules/data/energy';
import { SET_ENVIRONMENTS } from './modules/data/environments';
import { SET_MATERIALS } from './modules/data/materials';
import { SET_MEDIUMS } from './modules/data/mediums';
import { SET_PRODUCTS } from './modules/data/products';
import { SET_TRANSLATIONS } from './modules/data/translations';
import { SET_ADAPTERS } from './modules/data/adapters';
import { SET_SETTINGS } from './modules/data/settings';
import { SET_MATERIALSTANDARDS } from './modules/data/materialstandards';
import { SET_DATABASEDATE } from './modules/data/databasedate';

import { setLocalization } from './modules/app';

const store = configureStore();
store.dispatch(setLocalization());
var showDebug = false;

window.onkeyup = function(e) {
//    var key = e.keyCode ? e.keyCode : e.which;
    let key = e.key;
    if(window.globalKey == '' && key.toUpperCase() == 'D') {
        window.globalKey = 'D';
    } else if(window.globalKey == 'D' && key.toUpperCase() == 'E') {
        window.globalKey += 'E';
    } else if(window.globalKey == 'DE' && key.toUpperCase() == 'B') {
        window.globalKey += 'B';
    } else if(window.globalKey == 'DEB' && key.toUpperCase() == 'U') {
        window.globalKey += 'U';
    } else if (window.globalKey == 'DEBU' && key.toUpperCase() == 'G') {
        let state = store.getState();
        let prj = state.project;
        let calc = prj.calculations[prj.calculationIndex];
        let sect = calc.results.sectionResults[calc.sectionIndex];
        let outStr = '<h2>Debug information ' + prj.title + ', ' + calc.name + '</h2>';
        if(calc.type.indexOf('tank') != -1) {
            outStr += '<br /><b>-- Top --</b><br />';
            let side = sect.topLayers;
            outStr += 'Heatloss : ' + side.heatloss + '<br />';
            outStr += 'Hse : ' + side.alphae + '<br />';
            outStr += 'Hr : ' + side.alphaR + '<br />';
            outStr += 'Hcv : ' + side.alphaK + '<br />';
            outStr += 'Addition to lambda : ' + side.addition + '<br />';
            outStr += 'Joints effect multiplier : ' + side.joint + '<br />';
            for(let i = 0; i < side.layers.length; i++) {
                outStr += '<br /><b>Layer ' + i + '</b><br />';
                outStr += 'Surface temperature : ' + side.layers[i].surfaceTemperature + '<br />';
                outStr += 'Lambda : ' + side.layers[i].thermalConductivity[0] + '<br />';
            }

            outStr += '<br /><b>-- Side --</b><br />';
            side = sect.sideLayers;
            outStr += 'Heatloss : ' + side.heatloss + '<br />';
            outStr += 'Hse : ' + side.alphae + '<br />';
            outStr += 'Hr : ' + side.alphaR + '<br />';
            outStr += 'Hcv : ' + side.alphaK + '<br />';
            outStr += 'Addition to lambda : ' + side.addition + '<br />';
            outStr += 'Joints effect multiplier : ' + side.joint + '<br />';
            for(let i = 0; i < side.layers.length; i++) {
                outStr += '<br /><b>Layer ' + i + '</b><br />';
                outStr += 'Surface temperature : ' + side.layers[i].surfaceTemperature + '<br />';
                outStr += 'Lambda : ' + side.layers[i].thermalConductivity[0] + '<br />';
            }

            outStr += '<br /><b>-- Bottom --</b><br />';
            side = sect.bottomLayers;
            outStr += 'Heatloss : ' + side.heatloss + '<br />';
            outStr += 'Hse : ' + side.alphae + '<br />';
            outStr += 'Hr : ' + side.alphaR + '<br />';
            outStr += 'Hcv : ' + side.alphaK + '<br />';
            outStr += 'Addition to lambda : ' + side.addition + '<br />';
            outStr += 'Joints effect multiplier: ' + side.joint + '<br />';
            for(let i = 0; i < side.layers.length; i++) {
                outStr += '<br /><b>Layer ' + i + '</b><br />';
                outStr += 'Surface temperature : ' + side.layers[i].surfaceTemperature + '<br />';
                outStr += 'Lambda : ' + side.layers[i].thermalConductivity[0] + '<br />';
            }
        } else {
            outStr += 'Heatloss : ' + sect.heatloss + '<br />';
            outStr += 'Hse : ' + sect.alphae + '<br />';
            outStr += 'Hr : ' + sect.alphaR + '<br />';
            outStr += 'Hcv : ' + sect.alphaK + '<br />';
            outStr += 'Addition to lambda : ' + sect.addition + '<br />';
            outStr += 'Joints effect multiplier : ' + sect.joint + '<br />';
            if(calc.type.indexOf('duct') != -1) {
                outStr += 'Hsi : ' + sect.hSi + '<br />';
            }
            for(let i = 0; i < sect.layers.length; i++) {
                outStr += '<br /><b>Layer ' + i + '</b><br />';
                outStr += 'Surface temperature : ' + sect.layers[i].surfaceTemperature + '<br />';
                if(sect.layers[i].thermalConductivity && sect.layers[i].thermalConductivity.length) {
                    outStr += 'Lambda : ' + sect.layers[i].thermalConductivity[0] + '<br />';
                }
            }
        }
        // alert(outStr);
        const newWin = window.open();
        newWin.document.write(outStr);
        newWin.document.close();
        window.globalKey = '';
    } else {
        window.globalKey = '';
    }
//    alert(store)
};

if (process.env.NODE_ENV !== 'development') {
  const consolelog = console.log;

  console.log = () => {};

  window.enableLogs = () => {
    console.log = consolelog;
  };
}

render(
    <AppContainer>
        <Root store={store} history={history} />
    </AppContainer>,
    document.getElementById('root')
);

if (module.hot) {
    module.hot.accept('./containers/Root', () => {
        const newConfigureStore = require('./store/configureStore');
        const newStore = newConfigureStore.configureStore();
        const newHistory = newConfigureStore.history;
        const NewRoot = require('./containers/Root').default;
        render(
            <AppContainer>
                <NewRoot store={newStore} history={newHistory} />
            </AppContainer>,
            document.getElementById('root')
        );
    });
}


/*
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=claddings.json',    options: {}, props: { type:'application/json', successAction: SET_CLADDINGS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=energy.json',    options: {}, props: { type:'application/json', successAction: SET_ENERGY } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=environments.json',    options: {}, props: { type:'application/json', successAction: SET_ENVIRONMENTS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=materials.json',    options: {}, props: { type:'application/json', successAction: SET_MATERIALS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=mediums.json',    options: {}, props: { type:'application/json', successAction: SET_MEDIUMS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=products.json',    options: {}, props: { type:'application/json', successAction: SET_PRODUCTS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=translations.json',    options: {}, props: { type:'application/json', successAction: SET_TRANSLATIONS } } })
store.dispatch({ type: FETCH, payload: { url: 'http://calculus.paroc.com/?q=settings.json',    options: {}, props: { type:'application/json', successAction: SET_SETTINGS } } })
*/

if (process.env.NODE_ENV === 'production') {
    store.dispatch({ type: FETCH, payload: { url: 'data/claddings.json',    options: {}, props: { type: 'application/json', successAction: SET_CLADDINGS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/energy.json',    options: {}, props: { type: 'application/json', successAction: SET_ENERGY } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/environments.json',    options: {}, props: { type: 'application/json', successAction: SET_ENVIRONMENTS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/materials.json',    options: {}, props: { type: 'application/json', successAction: SET_MATERIALS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/mediums.json',    options: {}, props: { type: 'application/json', successAction: SET_MEDIUMS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/products.json',    options: {}, props: { type: 'application/json', successAction: SET_PRODUCTS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/translations.json',    options: {}, props: { type: 'application/json', successAction: SET_TRANSLATIONS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/valves-fittings-and-flanges.json',    options: {}, props: { type: 'application/json', successAction: SET_ADAPTERS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/settings.json',    options: {}, props: { type: 'application/json', successAction: SET_SETTINGS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/materialstandards.json',    options: {}, props: { type: 'application/json', successAction: SET_MATERIALSTANDARDS } } });
    store.dispatch({ type: FETCH, payload: { url: 'data/databasedate.json',    options: {}, props: { type: 'application/json', successAction: SET_DATABASEDATE } } });
} else {
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/claddings.json',    options: {}, props: { type: 'application/json', successAction: SET_CLADDINGS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/energy.json',    options: {}, props: { type: 'application/json', successAction: SET_ENERGY } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/environments.json',    options: {}, props: { type: 'application/json', successAction: SET_ENVIRONMENTS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/materials.json',    options: {}, props: { type: 'application/json', successAction: SET_MATERIALS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/mediums.json',    options: {}, props: { type: 'application/json', successAction: SET_MEDIUMS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/products.json',    options: {}, props: { type: 'application/json', successAction: SET_PRODUCTS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/translations.json',    options: {}, props: { type: 'application/json', successAction: SET_TRANSLATIONS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/valves-fittings-and-flanges.json',    options: {}, props: { type: 'application/json', successAction: SET_ADAPTERS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/settings.json',    options: {}, props: { type: 'application/json', successAction: SET_SETTINGS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/materialstandards.json',    options: {}, props: { type: 'application/json', successAction: SET_MATERIALSTANDARDS } } });
    store.dispatch({ type: FETCH, payload: { url: 'app/assets/data/databasedate.json',    options: {}, props: { type: 'application/json', successAction: SET_DATABASEDATE } } });
}
